import { useQuery } from 'react-query';

const useNameGeoData = (
  getNames: $TSFixMe,
  filter: $TSFixMe,
  integrationSettings: $TSFixMe,
  meta: $TSFixMe,
  pageContext: $TSFixMe
) => {
  const { zoom } = filter;
  return useQuery(
    zoom,
    () => getNames(filter, integrationSettings, meta, pageContext).then((resp: any) => resp),
    {
      refetchOnWindowFocus: false,
      staleTime: 86400000,
      retry: true
    }
  );
};

export default useNameGeoData;
